import { TSummaryResponse } from "domain/entities/generic-type";
import {TCreativeSummary } from "../entities/creative-summary-response";

export class CreativeSummaryModel {
  static from(creativeSummaryresponse: TSummaryResponse): TCreativeSummary {
    return {
      cards: creativeSummaryresponse.cards,
      range: creativeSummaryresponse.range,
      summary: {
        dataColumns: [
          {
            header: 'Creative',
            accessor: 'name',
          },
          {
            header: "Visitors",
            accessor: "visitors"
          },
          {
            header: "Converted",
            accessor: "converted"
          },
          {
            header: "Bounced",
            accessor: "bounced"
          },
          {
            header: "Avg. Time",
            accessor: "averageTime"
          },
          {
            header: "UTM",
            accessor: "utm"
          },
        ],
        dataRows: creativeSummaryresponse.table.map(
          (creativeSummary) => {
            return {
              name : creativeSummary.name,
              visitors: `${creativeSummary.visitors} (${creativeSummary.visitorsPercentage}%)`,
              converted: `${creativeSummary.converted} (${creativeSummary.convertedPercentage}%)`,
              bounced: `${creativeSummary.bounced} (${creativeSummary.bouncedPercentage}%)`,
              averageTime: creativeSummary.averageTime,
              utm: creativeSummary.utm,
            };
          }
        ),
      }
    }
  }
}
